<style lang="scss">
</style>

<template>
  <div>
    <Alert type="error"
           class="color-error">
      {{$t('erp.virtualstore.descrpattention',{defaultValue:'注意事项'})}}
      <ul style="list-style-type: disc;padding-left:20px;">
        <li>{{$t('erp.virtualstore.descrpattention1',{defaultValue:'必须同一虚拟仓的ERP SKU才能进行复制'})}}</li>
        <li>{{$t('erp.virtualstore.descrpattention2',{defaultValue:'同项目的ERP SKU才能进行复制'})}}</li>
        <li>{{$t('erp.virtualstore.descrpattention3',{defaultValue:'最多一次复制50条'})}}</li>
      </ul>
    </Alert>
    <div class="clearfix ">
      <span class="pull-left width-10per">{{$t('fbb.costmanage.explain',{defaultValue:'说明'})}}:</span>
      <Input class="pull-left width-90per"
             :rows="4"
             v-model="erpSku"
             type="textarea"
             :placeholder="$t('erp.virtualstore.manysku',{defaultValue:'多个SKU,换行分隔'})" />
    </div>
    <footer class="padding-top-15 text-right">
      <Button type="primary"
              class="width-15per"
              @click="submit">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
      <Button class="width-15per"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </div>
</template>

<script>
import { HttpSaTemplateSku } from '@/service/boss/allot'
export default {
  props: ['id'],
  data () {
    return {
      loading: false,
      erpSku: ''
    }
  },

  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      if (!(this.erpSku && this.id)) {
        this.$Message.error(this.$t('global.common.enter',{defaultValue:'请输入'})+'skus');
        return;
      }
      this.loading = true;
      HttpSaTemplateSku({ erpSku: this.erpSku.replace(new RegExp('\\n|\\r', 'g'), ','), id: this.id }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
        this.loading = false;
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
        this.loading = false;
      })
    }
  }
}

</script>

